import { atomWithImmer } from "jotai-immer";

import type { LocationModalState } from "../types";

export const initialState: LocationModalState = {
  isVisible: false,
  contactId: null,
  autoName: true,
  newAddress: {
    toggle: false,
    autoPostalCode: true,
  },
};

export const locationModalAtom =
  atomWithImmer<LocationModalState>(initialState);
